import { render } from "./admin-post-edit.vue?vue&type=template&id=20cfcbf7"
import script from "./admin-post-edit.vue?vue&type=script&lang=js"
export * from "./admin-post-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__